var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7337 0H4.45375C3.43001 0 2.44821 0.406677 1.72432 1.13057C1.00043 1.85446 0.59375 2.83626 0.59375 3.86L0.59375 32.14C0.59375 33.1637 1.00043 34.1455 1.72432 34.8694C2.44821 35.5933 3.43001 36 4.45375 36H15.4537V23.76H10.4137V18H15.4838V13.61C15.4838 8.61 18.4837 5.86 23.0037 5.86C24.5013 5.87978 25.9954 6.01014 27.4737 6.25V11.15H24.9538C22.4838 11.15 21.7038 12.68 21.7038 14.26V18H27.2337L26.3538 23.76H21.7038V36H32.7038C33.2132 36.004 33.7183 35.907 34.1901 35.7148C34.6619 35.5226 35.091 35.2389 35.4526 34.8801C35.8142 34.5213 36.1012 34.0944 36.2971 33.6241C36.4929 33.1538 36.5938 32.6494 36.5938 32.14V3.86C36.5938 2.83626 36.1871 1.85446 35.4632 1.13057C34.7393 0.406677 33.7575 0 32.7337 0V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.59375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.3f177defe25b8d98b5996025a6454843.svg";
export { ForwardRef as ReactComponent };